import bnbToken from "../abis/bnbToken";

const host = "https://bscscan.com/address/";

export default {
  title: "BNB",
  contractAddress: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
  abi: bnbToken.abi,
  url: `${host}/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c`,
  decimals: 18,
};
